module.exports = __webpack_public_path__ + "img/well3.f8477644.png";